import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

// Components
import Button from 'components/Button';

import styles from './styles.styl';

const ButtonComponent = ({ value, className, activeClass, selected, children, onClick }) => {
  function handleClick() {
    onClick(value);
  }

  return (
    <Button
      className={cn(styles.Button, className, {
        [styles.Button_selected]: selected,
        [activeClass]: selected,
      })}
      theme={selected ? 'default' : 'link'}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
};

ButtonComponent.propTypes = {
  className: PropTypes.string,
  activeClass: PropTypes.string,
  value: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ButtonComponent;
